module.exports = __webpack_public_path__ + "static/media/importICS2.67423287.png";